import Locomotive from './Locomotive'
import ElectricLocoSection from './ElectricLocoSection'

export default class ElectricLocomotive extends Locomotive {
    locoSections = Array<ElectricLocoSection>()

}